import { getCurrentUri } from 'apps/sso/redirectHandlers';
import {
  verifyUserLoginStatus,
  USER_LOGIN_STATUS,
  getUserFromExtras,
} from 'apps/user/helpers';
import { config } from 'api';
import { arrayContainsArray } from 'utils/array';
import { DELIVERY_PAGE_BF, SSO_BROKER_BF } from './const';
import { setNoRouteAccess } from 'apps/user/actions/user';

export function redirectToHomepageWhenBFDisabled(nState, replace, path, extras) {
  const redirectPath = '/';
  const user = getUserFromExtras(extras);

  const isBetaFeatureEnabled = arrayContainsArray(
    user.betaFeatures,
    [DELIVERY_PAGE_BF]
  );

  if (isBetaFeatureEnabled) return true;

  replace(redirectPath);
  return false;
}

export function redirectToSSOWhenUserLoggedOut(nState, replace, path, extras) {
  const redirectPath = '/login';
  const user = getUserFromExtras(extras);

  const isUserLoggedIn = verifyUserLoginStatus(
    user,
    USER_LOGIN_STATUS.LOGGED_IN
  );

  if (isUserLoggedIn) return true;

  replace(redirectPath);
  return false;
}

export function redirectToBroker(nextState, replace, path, extras) {
  const { store, network, history } = extras;
  const { dispatch } = store;
  const user = getUserFromExtras(extras);

  const isBrokerEnabled = arrayContainsArray(
    user.betaFeatures,
    [SSO_BROKER_BF]
  );

  // Ignore this handler when broker disabled
  if (!isBrokerEnabled) return Promise.resolve();

  const pageRedirectedFrom = getCurrentUri(history, network);

  return new Promise((res, reject) => {
    dispatch(getSsoUrls)
      .then((ssoUrls) => {
        const to = `${ssoUrls.brokerUrl}?success_redirect=${pageRedirectedFrom}`;
        network.redirectTo({ to, reload: true });
        dispatch(setNoRouteAccess('DO_NOT_REDIRECT'));
        reject();
      });
  });
}

function getSsoUrls(_, __, { network }) {
  return network.get(`${config.apiBasePath}/sso/urls`);
}
